/**
 *  @author Eugene Terentev <eugene@terentev.net>
 */
  let map;
  
  async function initMap() {

    const points = [
        { lat: 50.5228509301646, lng: 5.242712755422362, type: "etude", title: "NELLESSEN & VACCARI Notaires Associés", info: "<string>NELLESSEN & VACCARI Notaires Associés</string><br>Avenue Ch. et L. Godin 6, 4500 Huy" },
        { lat: 50.52378185099336, lng: 5.242890182742321, type: "parking", title: "Parking du parc" },
        { lat: 50.522586602967664, lng: 5.242861327400299, type: "parking", title: "Parking"},
        { lat: 50.52427950424872, lng: 5.24256926547245, type: "parking", title: "Parking Aqua Huy"},
        { lat: 50.52271574155771, lng: 5.241106351781117, type: "parking", title: "Parking centre culturel"},
        { lat: 50.520288783368585, lng: 5.242438185020169, type: "parking", title: "Parking Quadrilatère"},

    ]
    //https://www.google.com/maps/place/NELLESSEN+%26+VACCARI+Notaires+Associ%C3%A9s/@50.5227397,5.2443006,18.96z/data=!3m1!5s0x47c1a99cdece50d5:0x3547652046b3dda4!4m6!3m5!1s0x47c1a99d29718241:0xab5f21df5705bbb0!8m2!3d50.5228564!4d5.242786!16s%2Fg%2F1tkp43y6?entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D
    const { Map, InfoWindow } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
      "marker",
    );
    const { Place } = await google.maps.importLibrary("places");

    const infoWindow = new InfoWindow();

    map = new Map(document.getElementById("map"), {
      center: { lat: 50.5228509301646, lng: 5.242712755422362 },
      zoom: 16,
      mapId: "DEMO_MAP_ID",

    });

    for (const point of points) {

        const icon = document.createElement("div");

        if (point.type === "etude") {
            icon.innerHTML = '<img src="/img/map.png" style="width: 36px;">';
        }
        else if (point.type === "parking") {
            icon.innerHTML = '<i class="fa fa-car fa-lg"></i>';
        }
        const faPin = new PinElement({
            glyph: icon,
            glyphColor: point.type == "etude" ? "#fff": "#111",
            background: point.type == "etude" ? "#29334b" : "#ba9a64",
            borderColor: point.type == "etude" ? "#fff": "#111",
            scale: point.type == "etude" ? 1.5 : 1
          });
            const marker = new AdvancedMarkerElement({
                map,
                position: point,
                gmpClickable: true,
                content: faPin.element,
                title: point.title || "",
              });
        
              marker.addListener("click", ({ domEvent, latLng }) => {
                const { target } = domEvent;
        
                infoWindow.close();
                
                infoWindow.setContent(point.info || point.title || "");
                infoWindow.open(marker.map, marker);
              });
        


    }
  }
  
initMap();
